import React from 'react';
import { TaskMasterContextProvider } from '../../context';
import TaskMasterView from './TaskMasterView';

const TaskMaster = () => {
    return (
        <TaskMasterContextProvider>
            <TaskMasterView />
        </TaskMasterContextProvider>
    );
};

export default TaskMaster;
